import * as defaultImport from "@splunk/react-icons/Layout";
export * from "@splunk/react-icons/Layout";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
